import React from 'react';
import {useTranslation} from 'react-i18next';

import type {ButtonProps} from '@pexip/components';
import {BadgeCounter, Icon, IconTypes} from '@pexip/components';

import {TestId} from '../../../test/testIds';
import {useShortcutTranslation} from '../../hooks/useShortcutTranslation';
import {InMeetingInputControl} from '../InputControl/InMeetingInputControl.view';
import {getLangDirection} from '../../utils/getLangDirection';

export const ChatPanelToggleView: React.FC<
    ButtonProps & {
        newMessagesCount: number;
        isPanelOpen: boolean;
        isTouchDevice: boolean;
    }
> = ({isPanelOpen, newMessagesCount, isTouchDevice, ...props}) => {
    const {t, i18n} = useTranslation();
    const shortcut = useShortcutTranslation('N');
    const dir = getLangDirection(i18n);
    const actionLabel = t('meeting.toggle-chat-tooltip', 'Chat');
    const label = shortcut ? `${actionLabel} ${shortcut}` : actionLabel;

    return (
        <BadgeCounter
            number={0}
            isVisible={!isPanelOpen && newMessagesCount > 0}
            isTruncated
        >
            <InMeetingInputControl
                shouldShowTooltip={!isTouchDevice}
                tooltipPosition={dir === 'rtl' ? 'left' : 'right'}
                tooltipText={label}
                aria-label={label}
                aria-expanded={isPanelOpen}
                data-testid={TestId.ButtonChat}
                icon={<Icon source={IconTypes.IconChat} size={'small'} />}
                isActive={isPanelOpen}
                {...props}
            />
        </BadgeCounter>
    );
};
export type ChatPanelToggleProps = React.ComponentProps<
    typeof ChatPanelToggleView
>;
